import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ContactForm from "./components/ContactForm";
import sideStrips from "../../assets/images/side-strips.png";
import styles from "./styles/contact.module.scss";
import { useSelector } from "react-redux";
import { useTestimonialsQuery } from '../Testimonials/api/testimonialsApi';
import TestimonialsSection from '../../components/TestimonialsSection/TestimonialsSection';

function Contact(props) {

  const siteConfig = useSelector(state => state.site)
  const { data } = useTestimonialsQuery()

  return (
    <div className={styles.contactPage}>
      {
        siteConfig.domain?.includes('lgbtjobs') === true ?
          <img
            src={sideStrips}
            className={`${styles.sideStrips} ${styles.sideStrips1}`}
            alt=""
          />
          : ''
      }
      <div className="container">
        <h1>Contact Us</h1>
      </div>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      >
        <ContactForm />
      </GoogleReCaptchaProvider>
      <TestimonialsSection section={data?.section} />
    </div>
  );
}

export default Contact;
